import img1 from './Images/croped_img1.jpeg';
import img2 from './Images/croped_img2.jpeg';
import img3 from './Images/croped_img3.jpeg';

export const HomeSlides = [
  {
    id: 1,
    img: img1,
  },
  {
    id: 2,
    img: img2,
  },
  {
    id: 3,
    img: img3,
  },
];
// export const AboutSlides = [
//     {
//       id: 1,
//       img:
//         "https://www.susangreenecopywriter.com/wp-content/uploads/2013/01/iStock_000039291924_Medium.jpg",
//     },
//     {
//       id: 2,
//       img:
//         "https://eazyerp.com/img/section/aboutupdated.jpg",
//     },
//   ];